import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const ImagePreviewContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    '& img': {
        width: '100%',
        height: '200px',
        objectFit: 'cover',
        borderRadius: theme.shape.borderRadius,
    },
}));

export const MultipleImagePreviewContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
}));

export const ImagePreviewItem = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: '200px',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    '& .delete-button': {
        position: 'absolute',
        top: theme.spacing(0.5),
        right: theme.spacing(0.5),
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
        },
        zIndex: 1,
    },
}));

export const ImageUploadContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
}));
